// eslint-disable-next-line import/prefer-default-export
export const FORM_VALUES = {
  coding: '',
  business: '',
  productManagement: '',
  data: '',
  artificialIntelligence: '',
  communications: '',
};
